import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { FundService } from '../../services/fund.service'
import { DateService } from '../../services/date.service'
import * as CanvasJS from '../canvasjs.min';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Chart } from 'angular-highcharts';

@Component({
  selector: 'app-fund-compare-result',
  templateUrl: './fund-compare-result.component.html',
  styleUrls: ['./fund-compare-result.component.scss']
})
export class FundCompareResultComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  private subscribe: any
  //fund 1
  fundId1: number
  fundNameTh1: string
  fundNameEn1: string
  riskSpectrumId1: number
  reskSpectrumTh1: string
  fundPriceDate1: string
  navPublish1: number
  navDiff1: number
  NAVDiffPercent1: number
  investMentPort1: Array<Object> = []
  topFiveHolding1: Array<Object> = []
  investmentPolicy1: string
  minFirstTradeAmt1: number
  minTradeAmt1: number
  minFundGiftCard1: number
  buyTime1: string
  buyCondition1: string
  minBalanceUnit1: number
  minSellTradeAmt1: any
  minBalanceBath1: any
  sellTime1: string
  settlementDate1: number
  feeBuy1: string
  feeSell1: string
  feeSwitchIn1: string
  feeSwitchOut1: string
  Currency1: any

  //fund 2
  fundId2: number
  fundNameTh2: string
  fundNameEn2: string
  riskSpectrumId2: number
  reskSpectrumTh2: string
  fundPriceDate2: string
  navPublish2: number
  navDiff2: number
  NAVDiffPercent2: number
  investMentPort2: Array<Object> = []
  topFiveHolding2: Array<Object> = []
  investmentPolicy2: string
  minFirstTradeAmt2: number
  minTradeAmt2: number
  minFundGiftCard2: number
  buyTime2: string
  buyCondition2: string
  minBalanceUnit2: number
  minSellTradeAmt2: any
  minBalanceBath2: any
  sellTime2: string
  settlementDate2: number
  feeBuy2: string
  feeSell2: string
  feeSwitchIn2: string
  feeSwitchOut2: string
  Currency2: any

  labelChart1: Array<any> = []
  lineChartData1: any
  chartLabels1: Array<any> = []
  lineChartData2: any

  fundLabel1: string
  fundLabel2: string


  chart_line: any

  index_v: any

  chartOptions: any = {
    responsive: true,
    legend: {
      position: 'bottom'
    }
  }

  chartColors1: any[] = [
    {
      backgroundColor: 'rgba(0, 255, 0, 0)',
      borderColor: 'rgba(0, 21, 177, 1)'
    },
    {
      backgroundColor: 'rgba(0, 255, 0, 0)',
      borderColor: 'rgba(177, 0, 0, 1)'
    },
    {
      backgroundColor: 'rgba(0, 255, 0, 0)',
      borderColor: 'rgba(0, 153,47, 1)'
    },
    {
      backgroundColor: 'rgba(0, 255, 0, 0)',
      borderColor: 'rgba(243, 234,47, 1)'
    }
  ];

  donut_1: any
  donut_2: any

  doughnutChartData1: any
  doughnutChartData2: any

  flag: any


  constructor(private route: ActivatedRoute, private _fundInfoService: FundService, private _dateService: DateService,
    private router: Router, private ngxService: NgxUiLoaderService,) {

    this.lineChartData1 = []
    this.doughnutChartData1 = []
    this.doughnutChartData2 = []

  }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.subscribe = this.route.params.subscribe(params => {
      this.ngxService.start()
      this.index_v = "1";

      this._fundInfoService.getFundInfo(params.fundId1).subscribe(response => {
        this.fundId1 = response['Result']['FundId']

        this.fundNameEn1 = response['Result']['FundCode']
        this.riskSpectrumId1 = response['Result']['RiskSpectrumId']
        this.navPublish1 = response['Result']['NavPublish']
        this.navDiff1 = response['Result']['NAVDiff']
        this.NAVDiffPercent1 = response['Result']['NAVDiffPercent']
        this.investMentPort1 = response['Result']['Asset']
        this.topFiveHolding1 = response['Result']['Top5Holding']
        this.minFirstTradeAmt1 = response['Result']['MinFirstTradeAmt']
        this.minTradeAmt1 = response['Result']['MinTradeAmt']
        this.minFundGiftCard1 = response['Result']['MinFundGiftCard']
        this.buyTime1 = response['Result']['BuyTime']
        this.minBalanceUnit1 = response['Result']['MinBalanceUnit']

        if (this.flag == 'th') {
          this.fundNameTh1 = response['Result']['FundNameTh']
          this.reskSpectrumTh1 = response['Result']['RiskSpectrumTh']
          this.fundPriceDate1 = this._dateService.changeFormatDate(response['Result']['FundPriceDate1'])
          this.investmentPolicy1 = response['Result']['InvestmentPolicy']
          this.feeBuy1 = response['Result']['FeeBuy']
          this.feeSell1 = response['Result']['FeeSell']
          this.feeSwitchIn1 = response['Result']['FeeSwitchIn']
          this.feeSwitchOut1 = response['Result']['FeeSwitchOut']
          this.buyCondition1 = response['Result']['BuyCondition']
          this.sellTime1 = response['Result']['SellTime']
        } else {
          this.fundNameTh1 = response['Result']['FundNameEn']
          this.reskSpectrumTh1 = response['Result']['RiskSpectrumEn']
          this.fundPriceDate1 = this._dateService.changeFormatDate_2(response['Result']['FundPriceDate1'])
          this.investmentPolicy1 = response['Result']['InvestmentPolicyEn']
          this.feeBuy1 = response['Result']['FeeBuyEn']
          this.feeSell1 = response['Result']['FeeSellEn']
          this.feeSwitchIn1 = response['Result']['FeeSwitchInEn']
          this.feeSwitchOut1 = response['Result']['FeeSwitchOutEn']
          this.buyCondition1 = response['Result']['BuyConditionEn']
          this.sellTime1 = response['Result']['SellTimeEn']
        }

        if (response['Result']['MinSellTradeAmt'] === 0 || response['Result']['MinSellTradeAmt'] === null) {
          if (this.flag == 'th') {
            this.minSellTradeAmt1 = "ไม่กำหนด"
          } else {
            this.minSellTradeAmt1 = "Undefined"
          }
        } else {
          this.minSellTradeAmt1 = response['Result']['MinSellTradeAmt']
        }
        if (response['Result']['MinBalanceBaht'] === 0 || response['Result']['MinBalanceBaht'] === null) {
          if (this.flag == 'th') {
            this.minBalanceBath1 = "ไม่กำหนด"
          } else {
            this.minBalanceBath1 = "Undefined"
          }
        } else {
          this.minBalanceBath1 = response['Result']['MinBalanceBaht']
        }
        
        this.settlementDate1 = response['Result']['SettlementDate']
        //========================= DONUT =====================
        if (response['Result']['Asset'].length > 0) {
          var i: number
          for (i = 0; i < response['Result']['Asset'].length; i++) {
            var xxx: any;
            var bbb = response['Result']['Asset'][i]['Value']
            if (this.flag == 'th') {
              xxx = [response['Result']['Asset'][i]['Key'], bbb]
            } else {
              xxx = [response['Result']['Asset'][i]['KeyEn'], bbb]
            }
            this.doughnutChartData1.push(xxx)

          }
          this.donut_1 = new Chart({

            chart: {
              renderTo: 'container',
              type: 'pie'
            },
            title: {
              text: null
            },
            yAxis: {
              title: {
                text: 'Total percent market share'
              }
            },
            plotOptions: {
              pie: {
                shadow: false,
                dataLabels: {
                  enabled: false
                },
                showInLegend: false
              },
            },

            tooltip: {
              formatter: function () {
                return '<b>' + this.point.name + '</b>: ' + this.y.toFixed(2) + ' %';
              }
            },
            series: [{
              type: undefined,
              name: 'Browsers',
              data: this.doughnutChartData1,
              innerSize: '40%',
              showInLegend: false,
              dataLabels: {
                enabled: true,
                format: '{point.y:.2f}% <br/> {point.name}'
              }
            }]
          });
        }
        //===================================================== 





      })

      this._fundInfoService.getFundInfo(params.fundId2).subscribe(response => {
        this.fundId2 = response['Result']['FundId']
        this.fundNameEn2 = response['Result']['FundCode']
        this.riskSpectrumId2 = response['Result']['RiskSpectrumId']
        this.navPublish2 = response['Result']['NavPublish']
        this.navDiff2 = response['Result']['NAVDiff']
        this.NAVDiffPercent2 = response['Result']['NAVDiffPercent']
        this.investMentPort2 = response['Result']['Asset']
        this.topFiveHolding2 = response['Result']['Top5Holding']
        this.minFirstTradeAmt2 = response['Result']['MinFirstTradeAmt']
        this.minTradeAmt2 = response['Result']['MinTradeAmt']
        this.minFundGiftCard2 = response['Result']['MinFundGiftCard']
        this.buyTime2 = response['Result']['BuyTime']
        this.minBalanceUnit2 = response['Result']['MinBalanceUnit']

        if (this.flag == 'th') {
          this.fundNameTh2 = response['Result']['FundNameTh']
          this.reskSpectrumTh2 = response['Result']['RiskSpectrumTh']
          this.fundPriceDate2 = this._dateService.changeFormatDate(response['Result']['FundPriceDate1'])
          this.investmentPolicy2 = response['Result']['InvestmentPolicy']
          this.feeBuy2 = response['Result']['FeeBuy']
          this.feeSell2 = response['Result']['FeeSell']
          this.feeSwitchIn2 = response['Result']['FeeSwitchIn']
          this.feeSwitchOut2 = response['Result']['FeeSwitchOut']
          this.buyCondition2 = response['Result']['BuyCondition']
          this.sellTime2 = response['Result']['SellTime']
        } else {
          this.fundNameTh2 = response['Result']['FundNameEn']
          this.reskSpectrumTh2 = response['Result']['RiskSpectrumEn']
          this.fundPriceDate2 = this._dateService.changeFormatDate_2(response['Result']['FundPriceDate1'])
          this.investmentPolicy2 = response['Result']['InvestmentPolicyEn']
          this.feeBuy2 = response['Result']['FeeBuyEn']
          this.feeSell2 = response['Result']['FeeSellEn']
          this.feeSwitchIn2 = response['Result']['FeeSwitchInEn']
          this.feeSwitchOut2 = response['Result']['FeeSwitchOutEn']
          this.buyCondition1 = response['Result']['BuyConditionEn']
          this.sellTime2 = response['Result']['SellTimeEn']
        }


        if (response['Result']['MinSellTradeAmt'] === 0 || response['Result']['MinSellTradeAmt'] === null) {
          if (this.flag == 'th') {
            this.minSellTradeAmt2 = "ไม่กำหนด"
          } else {
            this.minSellTradeAmt2 = "Undefined"
          }
        } else {
          this.minSellTradeAmt2 = response['Result']['MinSellTradeAmt']
        }
        if (response['Result']['MinBalanceBaht'] === 0 || response['Result']['MinBalanceBaht'] === null) {
          if (this.flag == 'th') {
            this.minBalanceBath2 = "ไม่กำหนด"
          } else {
            this.minBalanceBath2 = "Undefined"
          }
        } else {
          this.minBalanceBath2 = response['Result']['MinBalanceBaht']
        }
        this.settlementDate2 = response['Result']['SettlementDate']

        //========================= DONUT =====================
        if (response['Result']['Asset'].length > 0) {
          var i: number
          for (i = 0; i < response['Result']['Asset'].length; i++) {
            var xxx: any;
            var bbb = response['Result']['Asset'][i]['Value']
            if (this.flag == 'th') {
              xxx = [response['Result']['Asset'][i]['Key'], bbb]
            } else {
              xxx = [response['Result']['Asset'][i]['KeyEn'], bbb]
            }
            this.doughnutChartData2.push(xxx)

          }
          this.donut_2 = new Chart({

            chart: {
              renderTo: 'container',
              type: 'pie'
            },
            title: {
              text: null
            },
            yAxis: {
              title: {
                text: 'Total percent market share'
              }
            },
            plotOptions: {
              pie: {
                shadow: false,
                dataLabels: {
                  enabled: false
                },
                showInLegend: false
              },
            },

            tooltip: {
              formatter: function () {
                return '<b>' + this.point.name + '</b>: ' + this.y.toFixed(2) + ' %';
              }
            },
            series: [{
              type: undefined,
              name: 'Browsers',
              data: this.doughnutChartData2,
              innerSize: '40%',
              showInLegend: false,
              dataLabels: {
                enabled: true,
                format: '{point.y:.2f}% <br/> {point.name}'
              }
            }]
          });
        }
        //===================================================== 



      })
      //========================== Graph =======================
      this._fundInfoService.Graph(params.fundId1, '1').subscribe(response => {

        this.labelChart1 = response['date']
        this.lineChartData1 = response['series'][0]['data']
        this.fundLabel1 = response['series'][0]['name_th']

        //========================== Graph =======================
        this._fundInfoService.Graph(params.fundId2, '1').subscribe(response => {
          this.lineChartData2 = response['series'][0]['data']
          this.fundLabel2 = response['series'][0]['name_th']

          this.chart_line = new Chart({
            title: {
              text: null
            },

            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.labelChart1,
            },
            yAxis: {
              title: {
                text: null
              }
            },

            legend: {
              layout: 'horizontal',
              verticalAlign: 'bottom',
              x: 0,
              y: 0,
            },
            series: [{
              type: undefined,
              name: this.fundLabel1,
              color: '#ad3030',
              data: this.lineChartData1
            }, {
              type: undefined,
              name: this.fundLabel2,
              color: '#c5aa00',
              data: this.lineChartData2
            }]


          })

          this.ngxService.stop()
        })

      })



    })
  }


  onSearchGraph(index_val) {
    this.ngxService.start()
    this.index_v = index_val;
    this.labelChart1.length = 0;
    this.lineChartData1.length = 0;
    this.chartLabels1.length = 0;

    //========================== Graph =======================
    this._fundInfoService.Graph(this.fundId1.toString(), index_val).subscribe(response => {

      this.labelChart1 = response['date']
      this.lineChartData1 = response['series'][0]['data']
      this.fundLabel1 = response['series'][0]['name_th']

      //========================== Graph =======================
      this._fundInfoService.Graph(this.fundId2.toString(), index_val).subscribe(response => {
        this.lineChartData2 = response['series'][0]['data']
        this.fundLabel2 = response['series'][0]['name_th']

        this.chart_line = new Chart({
          title: {
            text: null
          },

          subtitle: {
            text: null
          },
          xAxis: {
            categories: this.labelChart1,
          },
          yAxis: {
            title: {
              text: null
            }
          },

          legend: {
            layout: 'horizontal',
            verticalAlign: 'bottom',
            x: 0,
            y: 0,
          },
          series: [{
            type: undefined,
            name: this.fundLabel1,
            color: '#ad3030',
            data: this.lineChartData1
          }, {
            type: undefined,
            name: this.fundLabel2,
            color: '#c5aa00',
            data: this.lineChartData2
          }]
        })

        this.ngxService.stop()
      })

    })





  }




  isPositive(value) {
    if (Math.sign(value) == 1) {
      return true
    } else if (Math.sign(value) == -1 || Math.sign(value) == 0) {

      return false
    }
  }

  showOnlyValue(value) {
    return (Math.abs(value)).toFixed(4)
  }

  fixFloatDigit(value) {
    return value.toFixed(2)
  }

  goToFundDetail(fundId) {

    this.router.navigate(['/fund/detail/', fundId, 'THB'])

  }
}

